import React from 'react';
import PropTypes from 'prop-types';

import Message from '../message';

import I18n from '@app/modules/i18n/index';

const UploaderMessage = ({ transfer, setMessage }) => {
  return (
    <div className="wizard__box">
      <h3>{I18n.t('transfer.mobile.message.title')}</h3>
      <Message
        key="message"
        name="message"
        transfer={transfer}
        defaultValue={transfer.message}
        placeholder={I18n.t('transfer.mobile.message.placeholder')}
        onChange={setMessage}
      />
    </div>
  );
};

UploaderMessage.propTypes = {
  transfer: PropTypes.object.isRequired,
  setMessage: PropTypes.func.isRequired,
};

export default UploaderMessage;
